import { DisabledPrompt, Link, useBCMSContext, useParams, useRoute } from "@bcm-dev/bcms-vite";
import { UIPrimaryButton } from "components/ui/UIButton";
import { Card } from "model";
import React from "react";
import { ImageAsset } from "res";
import "./styles.css";
/**
 * @function ReportConfirmationView
 * @param {STRING} lastFour - the last four digits of the card
 * @param {STRING} owner - the name listed on the card
 * @param {STRING} street - the street address that the owner is listed at
 * @param {STRING} city - the ciy that the owner is listed at
 * @param {STRING} state - the state that the owner is listed at
 * @param {STRING} zipCode - the zip-code that the owner is listed at
 * @return {React.Component}
 * @exported true
 * @description The main component for ReportConfirmationView
 * @example
 * <ReportConfirmationView lastFour="x1234" owner="John Doe" street="123 Sesame Street" city="Town" state="Nebraska" zipCode="68504" />
 */
export default function ReportConfirmationView(props) {
  const globalController = useBCMSContext();
  const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const card = Card.initByID(cardID);
const user = globalController.state.user;
  const lastFour = card.lastFour ?? "[lastFour]";
  const owner = user.name ?? "[owner]";
  const street = user.street ?? "[street]";
  const city = user.city ?? "[city]";
  const state = user.state ?? "[state]";
  const zipCode = user.zip ?? "[zipCode]";
  const navigate = useRoute();

  return (
    <div className="report-confirmation-view text-center">
        <div className="framed-image-container">
          <ImageAsset id="CardCheckmarkIcon" />
        </div>
      <p className="new-card-confirmation"><b>Your new card ending in {lastFour} is on its way!</b></p>
      <p className="flex-container center">View your card credentials via&nbsp;<DisabledPrompt><Link>Reveal Card</Link></DisabledPrompt>&nbsp;option on the home page.</p>
      <div className="address-group">
        <p>{owner}</p>
        <p>{street},</p>
        <p>{city},</p>
        <p>{state} - {zipCode}</p>
      </div>
      <p>Remember to update your card on file with your merchants and service providers.</p>
      <p className="traveling-statement center flex-container">Traveling internationally?&nbsp;<DisabledPrompt><Link>Create a Travel Plan.</Link></DisabledPrompt></p>
      <UIPrimaryButton text="Done" onClick={ evt => navigate(`/home/recenttransactions/${ cardID }`) } />
    </div>
  );
}